$(function () {
    if (!$('#book-an-interpreter').length) return false;

    let failed_tries = 0;

    manageHiddenFields();

    $("#submit_book_interpreter_form").on('click', function(e) {
        e.preventDefault();

        $('.centered-spinner').show();

        let form = $('form.booking-form');
        let form_data = getFormData(form);

        let formData = new FormData(form[0]);

        // Check if the form is well completed
        if (!check_form_data(form_data, form)) {
            $('.centered-spinner').hide();
            failed_tries++;
            failed_tries_popup();
            return false;
        }

        $.ajax({
            type: "POST",
            url: getApiURL("bookings") + '/anonymous',
            headers: { "Token": $.cookie('token_api') },
            data: formData,
            cache: false,
            contentType: false,
            processData: false,
            success: function (data) {
                ATLAlerts.addSuccess(`The booking has been successfully created. If you want to make another booking please complete the form.`);
                $('html, body').animate({ scrollTop: $('html').offset().top }, 1000);
                $('#atl-alerts-div').append(ATLAlerts.displayAlerts(true));
                reset_form();
                $('.centered-spinner').hide();
                return false;
            },
            error: function (request, textStatus, errorThrown) {
                alert("Something went wrong: " + errorThrown);
                ATLAlerts.addError(`Unable to make a booking, please try again.`);
                $('html, body').animate({ scrollTop: $('html').offset().top }, 1000);
                $('#atl-alerts-div').append(ATLAlerts.displayAlerts(true));
                $('.centered-spinner').hide();
            }
        });
        return false;
    });

    function failed_tries_popup() {
        if (failed_tries >= 3 && $('form.booking-form').attr('id') == "book-an-interpreter") {

            var failed_input = '<textarea id="failed_input" name="failed_input" placeholder="Enter your booking details here" rows="13" style="width:97.5%"></textarea>';
            let dialog = showBinaryChoiceDialog({
                title: 'Any problem in creating new booking ?',
                body: "<p>We have detected a few failed submissions of this form.<br />Please use the area bellow to provide your contact details/your interpreting request and we will get back to you as soon as possible.</p><p><big>Please precise your name, phone number and email address.</big></p><br />" + failed_input + "<br />",
                yesButton: {
                    title: 'Keep on booking manually',
                    width: '260px',
                    onClick: function() {
                        dialog.modal('hide');
                        return false;
                    }
                },
                noButton: {
                    title: 'Submit',
                    onClick: function() {
                        $.ajax({
                            type: "POST",
                            url: getApiURL("bookings") + '/anonymous/failed',
                            headers: { "Token": $.cookie('token_api') },
                            data: {
                                failed_text: $('#failed_input').val()
                            },
                            dataType: 'json',
                            success: function (data) {
                                ATLAlerts.addSuccess(data.detail);
                                $('.btn-action').css({'display': "inline-block"});
                                dialog.modal('hide');
                                $('html, body').animate({ scrollTop: $('html').offset().top }, 1000);
                                $('#atl-alerts-div').append(ATLAlerts.displayAlerts(true));
                                reset_form();
                                return false;
                            },
                            error: function (request, textStatus, errorThrown) {
                                alert("Something went wrong: " + errorThrown);
                                ATLAlerts.addError('Something went wrong. The mail didn\'t send to ATL administration. Please call us to make your booking by phone.');
                                $('.btn-action').css({'display': "inline-block"});
                                dialog.modal('hide');
                                $('html, body').animate({ scrollTop: $('html').offset().top }, 1000);
                                $('#atl-alerts-div').append(ATLAlerts.displayAlerts(true));
                                return false;
                            }
                        });
                        return false;
                    }
                }
            });
        }
    }

    $("#duration").on("change", function() {
        let new_duration = $(this).val();
        // TODO do it better
        if (new_duration == "15m" || new_duration == "30m") {
            // Remove the short teleconference option
            $("#short-teleconference").show();
            $("label[for=short-teleconference]").show();
        } else {
            $("#short-teleconference").hide();
            $("label[for=short-teleconference]").hide();
            if ($("#short-teleconference").is(":checked")) {
                $("#short-teleconference").prop("checked", false);
            }
        }
    });
    // Prevent the default display
    if ($("#duration").val() == "1h") {
        $("#short-teleconference").hide();
        $("label[for=short-teleconference]").hide();
    }

    function reset_form() {
        $('input[type=text], input[type=email], textarea, select').val('');
		$('input[type=checkbox]').prop('checked', false);
    }

    function check_form_data(form_data, form) {
        if (form_data['company'] === "") {
            alert("Please fill out the Name of Company / Individual field.");
            return false;
        }

        if (form_data['street_address'] === "") {
            alert("Please fill out the Street Address field.");
            return false;
        }

        if (form_data['state'] === "" || form_data['postcode'] === "" || form_data['suburb'] === "") {
            alert("Please fill out the City, Suburb and Postcode fields.");
            return false;
        }

        if (form_data['telephone'] === "") {
            alert("Please fill out the Telephone field");
            return false;
        }

        if (form_data['email'] === "") {
            alert("Please fill out the Email Address field");
            return false;
        }

        let email = form_data['email'];
        if (!isValidEmail(email)) {
            alert("Please enter a valid Email Address");
            return false;
        }

        if (email != $(form).find('#confirm-email').val()) {
            alert("The email and confirmation email addresses do not match");
            return false;
        }

        if ($(form).find("#additional-email-checkbox").is(":checked") && !isValidEmail($(form).find('#additional-email').val())) {
            alert("Please enter a valid Additional Email Address");
            return false;
        }

        if (!isFutureDate(form_data['datetime'])) {
            alert("Please enter a booking Date, Time in the future");
            return false;
        }

        if (!isValidDuration(form_data['duration'])) {
            alert("Please enter a valid duration");
            return false;
        }

        let language = form_data['language'];
        // Check min duration for Auslan
        if (language === "Auslan" && !checkIfDurationIsOver(form_data['duration'], 2)) {
            alert("The duration must be over 2 hours for Auslan language");
            return false;
        }

        if (language === "" || (language === "Other" && form_data['language_name'] === '')) {
            alert("Please fill out the Language field");
            return false;
        }

        if (form_data['client'] === "") {
            alert("Please fill out the Client's Name field");
            return false;
        }

        if (form_data['job_reference'] === "") {
            alert("Please fill out the Claim No / Job Ref field");
            return false;
        }

        if (form_data['contact_person'] === "") {
            alert("Please fill out the Contact Person field");
            return false;
        }

        if (form_data['job_type'] === undefined || form_data['job_type'] === "") {
            alert("Please fill out the Job Type field");
            return false;
        }

        if (form_data['job_type'] === undefined || form_data['job_code'] === "") {
            alert("Please fill out the Job Code field");
            return false;
        }

        if (form_data['job_type'] !== 'teleconference' && form_data['job_code2'] === 'teleconference_short') {
            alert("Please fill out the Job Code field");
            return false;
        }

        if (form_data['job_type'] === 'onsite' && form_data['job_location'] === "") {
            alert("Please fill out the Job Location field");
            return false;
        }

        if (form_data['job_type'] === 'teleconference' && form_data['job_phone'] === "") {
            alert("Please fill out the Client Phone Number field");
            return false;
        }

        if (form_data['job_type'] === 'videoconference' && form_data['videoconference_info'] === "") {
            alert("Please fill out the Videoconference Info field");
            return false;
        }

        if (form_data['invoice_email'] !== "" && !isValidEmail(form_data['invoice_email'])) {
            alert("Please enter a valid Invoice Email");
            return false;
        }

        if (form_data['invoice_company'] === "") {
            alert("Please fill out the Invoice Company field");
            return false;
        }

        if (form_data['invoice_street_address'] === "") {
            alert("Please fill out the Street Address field");
            return false;
        }

        if (form_data['invoice_state'] === "" || form_data['invoice_postcode'] === "" || form_data['invoice_suburb'] === "") {
            alert("Please fill out the Invoice City, Suburb and Postcode fields.");
            return false;
        }

        if (form_data['instructed_by'] === "") {
            alert("Please fill out the Instructed By field");
            return false;
        }

        if (form_data['contact_phone'] === "") {
            alert("Please fill out the Contact Phone No. field");
            return false;
        }

        return true;
    }
    
    function manage_sub_job_code(job_type, job_code, sub_job_code) {
        switch (job_type) {
            case "onsite": 
                return sub_job_code !== '' ? sub_job_code : job_code;

            case "teleconference":
                return job_code;
            
            case "videoconference":
                return job_code;
            
            default: return '';
        }
    }

    function manageHiddenFields() {
        $('[data-extralink]').on('click', function(e) {
            e.preventDefault();
            $('[data-extrafield=' + $(this).data('extralink') + ']').show();
            $(this).hide();
        });
    }

    function checkIfDurationIsOver(time, durationToCheck) {
        let days = 0;
        let hours = 0;
        let minutes = 0;
        if (duration = time.match(/(\d*)h (\d*)m/)) {
            hours = Number(duration[1]);
            minutes = Number(duration[2]);
        } else if (duration = time.match(/(\d*)h/)) {
            hours = Number(duration[1]);
        } else if (duration = time.match(/(\d*)m/)) {
            minutes = Number(duration[1]);
        }
        if (duration = time.match(/(\d*.?5?)d/)) {
            days = Number(duration[1]);
        }
        let total = days * 24 + hours + minutes / 60;
        return durationToCheck <= total;
    }
});